// Copyright (C) 2017 Comcast Corporation, All Rights Reserved

/**
 * @class
 */
window.SmallPromoRowWidget = ( function()
{
    "use strict";

    SmallPromoRowWidget.prototype = new CollectionRowWidget();

    function SmallPromoRowWidget(){}

    SmallPromoRowWidget.prototype.init = function( params )
    {
        params.type = SmallPromoCellWidget;
        params.y    = _x2.scaleVal( 150 ) - _x2.scaleVal( 13 );
        params.h    = _x2.scaleValInt( 376 );

        CollectionRowWidget.prototype.init.call( this, params );
        this._className  = "SmallPromoRowWidget";

        return this;
    };

    SmallPromoRowWidget.prototype.getHeightUnfocused = function()
    {
        return _x2.scaleValInt( 506 );
    };

    return SmallPromoRowWidget;

})();
